// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__KAMHo","itemA":"Write_itemA__28TI5","itemB":"Write_itemB__1z8Sq","itemC":"Write_itemC__2ZHu1","itemD":"Write_itemD__CGoiC"};